import { useContext, useEffect, useState } from "react";
import { CognitoContext, UserProviderActions } from "../../contexts/cognito/cognito-provider";
import { CoreServiceSelector } from "../../services/core/service-selector";
import { AppRouteNames } from "../../routes/app-routes";
import { useNavigate } from "react-router-dom";
import ResponsivePrimaryNav from "./ResponsivePrimaryNav";
import HistoryIcon from '@mui/icons-material/History';
import QrCodeScannerOutlinedIcon from '@mui/icons-material/QrCodeScannerOutlined';
import CampaignOutlinedIcon from '@mui/icons-material/CampaignOutlined';
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import { useToast } from "../toast/toast-context";

const navIconStyle = { fontSize: 26 };
export const PortalSideMenu = ({ menu, asSideMenu, asTopMenu }) => {
  const [Menu, setMenu] = useState(menu);
  const { state, dispatch } = useContext(CognitoContext);
  const navigate = useNavigate();
  const { error: showErrorToast } = useToast();

  const navigateToLogin = () => {
    dispatch({ type: UserProviderActions.setSession, session: null });
    navigate(AppRouteNames.signin);
  };

  const getUserInfo = async () => {
    if (!state.session) return;
    const userInfoService = CoreServiceSelector.GetUserInfoService(state.session);
    userInfoService.setUnauthorisedHandler(navigateToLogin);

    const menuData = await userInfoService.getUserMenu().catch((err) => {
      console.log(err);
      if (err?.response?.status !== 401) {
        showErrorToast("Couldn't load the navigation menu. Please refresh the page.");
      }
    });
    setMenu(menuData);

    if (!userInfoService.getSavedUserInfo() || !state.userInfo) {
      const userInfo = await userInfoService.getUserInfo().catch((err) => {
        console.log("quit from side menu", err);
        if (err?.response?.status !== 401) {
          showErrorToast("Couldn't load your account information. Please refresh the page.");
        }
      });
      dispatch({ type: UserProviderActions.setUserInfo, userInfo });
    }
  };

  useEffect(() => {
    getUserInfo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state?.session]);

  const primaryCandidates = [
    { to: "/redeem-voucher", label: "Redeem", customIcon: <QrCodeScannerOutlinedIcon style={navIconStyle} />, alias: [] },
    { to: "/redemption-history", label: "History", customIcon: <HistoryIcon style={navIconStyle} />, alias: [] },
    { to: "/venue-listing", label: "Promote", customIcon: <CampaignOutlinedIcon style={navIconStyle} />, alias: [] },
    { to: "/help-support", label: "Help", customIcon: <HelpOutlineOutlinedIcon style={navIconStyle} />, alias: [], hideLabelMobile: true },
    { to: "/my-profile", label: "Profile", customIcon: <PersonOutlineOutlinedIcon style={navIconStyle} />, alias: ["/users-list", "/add-user", "/edit-user"], hideLabelMobile: true },
  ];

  const allUrls = (Menu?.items || [])
    .flatMap((grp) => grp.items || [])
    .map((it) => it.url)
    .filter(Boolean);

  // Promote, Help & Profile are universal (always shown); Redeem & History are
  // gated by the server-provided menu (access level / company).
  const alwaysShow = ["/venue-listing", "/help-support", "/my-profile"];
  const primaryItems = Menu
    ? primaryCandidates.filter((p) =>
        alwaysShow.includes(p.to) || allUrls.some((u) => u.startsWith(p.to))
      )
    : primaryCandidates;

  if (asSideMenu) {
    return <ResponsivePrimaryNav items={primaryItems} />;
  }

  if (asTopMenu) {
    return <ResponsivePrimaryNav items={primaryItems} />;
  }

  return null;
};
